export default __webpack_public_path__ + "static/media/map.82056140.png";